<template lang="pug">
  FormModal(title="Edit Translation", :endpoint="endpoint", method="PUT", :data="data", v-bind="$attrs", @success="success")
    InputGroup(label="Key", name="key"): TextInput(v-model="data.key", readonly)
    InputGroup(label="Description", name="description", :error="errors.description"): TextInput(v-model="data.description", :disabled="translating")
    hr.mb-8
    template(v-for="locale in locales")
      InputGroup(:label="`${locale.name} — ${locale.locale}`", :name="`translations.${locale.locale}`")
        TextInput(
          :name="`translation-${locale.locale}`",
          v-model="data.translations[locale.locale]",
          :disabled="translating",
          :prepend="data.translations[locale.locale] ? locale.icon : null",
          :prepend-icon="data.translations[locale.locale] ? null : 'exclamation-triangle'"
        )

    template(v-slot:footer)
      a.text-supplement(@click="$emit('close', false)") Cancel
      div.flex
        Button.mr-3(type="secondary", :disabled="translating || !data.translations.en", @click="reTranslate")
          template(#prepend): Icon(:icon="translating ? 'spinner' : 'language'", :spin="translating")
          span {{ translating ? "Translating…" : "Re-translate" }}
        Button(type="primary", submit) Update Translation
</template>

<script>
import { EditModalMixin } from "@syntax51/app-kit"

export default {
  mixins: [EditModalMixin],
  props: {
    locales: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    translating: false,
    errors: {},
    data: {
      key: "",
      description: "",
      translations: {}
    }
  }),
  methods: {
    async reTranslate() {
      if (!this.data.translations.en) return

      this.translating = true
      this.errors = {}

      try {
        const response = await this.$api.post("translations/translate", {
          description: this.data.description,
          value: this.data.translations.en
        })

        this.data.translations = { ...this.data.translations, ...response.data.translations }
      } catch (error) {
        // The translate request runs outside the form's submit lifecycle, so surface its
        // validation messages through InputGroup's `error` prop (a string per field).
        const errors = error?.response?.data?.errors
        if (errors) {
          this.errors = Object.fromEntries(
            Object.entries(errors).map(([field, messages]) => [field, [].concat(messages).join(" ")])
          )
        } else {
          this.$notification.error(error?.response?.data?.message || "The translation could not be completed.")
        }
      } finally {
        this.translating = false
      }
    },
    success() {
      this.$notification.success(`The translation for **${this.data.key}** has been updated.`)
      this.$emit("close", true)
    }
  }
}
</script>
